<aside class="col-md-12 mb-0 h-100-margin px-0 px-sm-4" [ngClass]="{'cargo-list-modal-mode': modalMode}">
  <div *ngIf="hasOperations && !modalMode" [ngClass]="{'operations-div-inline':hasOperationsInline||hasOperationsInlineLeft,
                'operations-div-inline--own-row':hasOperationsInline,
                'operations-div-top':hasOperationsTop,
                'operations-div-top-extra': hasOperationsTopExtra
              }">
    <app-list-operations [itemsSelecteds]="itemsSelecteds" [options]="optionsFilter" [typeList]="typeList"
      (refreshActualList)="refreshActualList()" (showDialog)="showDialog($event)"
      [filters]="filters"></app-list-operations>
  </div>
  <div id="mainListFreightList" class="container-list" [ngClass]="{
                'h-operations-inline':hasOperationsInline||hasOperationsInlineLeft,
                'h-operations-inline--own-row':hasOperationsInline,
                'h-operations-top':hasOperationsTop,
                'h-operations-top-extra':hasOperationsTopExtra,
                'h-100-margin':!hasOperations}">
    <div *ngIf="!modalMode"
      [ngClass]="{'d-flex flex-column-reverse flex-sm-row mt-3 mt-sm-0 justify-content-between':hasOperationsInlineLeft }">
      <div *ngIf="hasOperationsInlineLeft" class="total-container">
        <div class="total-item total-default cursor-pointer" [ngClass]="{'active': !filterByUncared}"
          (click)="setFilterByUncared(false)">
          <small class="m-0 p-0" *ngIf="!filterByUncared">Total servicios</small>
          <b class="text-bold" *ngIf="!filterByUncared && !totalsHeaderLoading">{{totalCargos || 0}}</b>
          <span class="total-counter-skeleton" *ngIf="!filterByUncared && totalsHeaderLoading"></span>
          <small class="m-0 p-0 text-wrap-balance text-bold" *ngIf="filterByUncared">Ver todos los servicios</small>
        </div>
        <div class="total-item total-red cursor-pointer" [ngClass]="{'active': filterByUncared}"
          (click)="setFilterByUncared(true)">
          <ng-container *ngIf="filterByUncared; else uncaredAction">
            <small class="m-0 p-0">Sin atender</small>
            <b class="text-bold" *ngIf="!totalsHeaderLoading">{{totalUncaredCargos || 0}}</b>
            <span class="total-counter-skeleton" *ngIf="totalsHeaderLoading"></span>
          </ng-container>
          <ng-template #uncaredAction>
            <small class="m-0 p-0 text-wrap-balance text-bold">Ver servicios sin atender</small>
          </ng-template>
        </div>
      </div>
      <app-list-filter [options]="optionsFilter" [typeList]="typeList"
        (refreshList)="refreshList($event)"></app-list-filter>
    </div>
    <ng-container *ngIf="cargoListLoading; else cargoListContent">
      <app-skeleton-loader variant="cargo-list" [rows]="5"></app-skeleton-loader>
    </ng-container>

    <ng-template #cargoListContent>
      <div *ngIf="paginationList.getList().length" class="container-list-body" infinite-scroll
        [infiniteScrollDistance]="paginationList.getScrollDistance()"
        [infiniteScrollThrottle]="paginationList.getThrottle()" [scrollWindow]="false" (scrolled)="onScrollDown()">
        <div class="d-flex justify-content-end">
          <div class="list-select-all mr-2" select-item-list [list]="paginationList.getList()"
            (onSelectItem)="onSelectItem($event)" *ngIf="showSelectAll" [type]="'selectAll'"
            [isSelectableFunction]="isSelectableFunction"></div>
        </div>

        <div class="col-md-12 mb-md-0 mb-12"
          *ngFor="let cargo of paginationList.getList(); let i = index; trackBy: trackByCargo">
          <app-cargo-item [cargo]="cargo" [typeList]="typeList" select-item-list [option]="optionsFilter"
            [selectableItem]="getActiveItemSelected(cargo)" [item]="cargo" [list]="paginationList.getList()"
            [checked]="!!cargo?.checked" [filters]="filters"
            [filteredCargosTurns]="getFilteredCargo(cargo?.consecutive, cargo?.cargoFeature?.vehicleType?.name, cargo?.cargoFeature?.uploadDownload?.origin?.municipalityCode, cargo?.dateLoad, cargo)"
            (onSelectItem)="onSelectItem($event)" (applyFilter)="refreshList()" (refreshCargo)="refreshCargo($event,i)"
            (navigate)="navigate.emit($event)">
          </app-cargo-item>
        </div>
      </div>

      <div class="scroll-page-loader" *ngIf="loadingNextPage" role="status" aria-label="Cargando más servicios">
        <span class="scroll-page-loader__spinner" aria-hidden="true"></span>
        <span class="scroll-page-loader__text">Cargando más resultados</span>
      </div>

      <div *ngIf="!paginationList.getList().length" class="container_no_results">
        <div class="icon"><i class="fas fa-calendar-times"></i></div>
        <h4 class="text-bold text-center">No hay resultados que coincidan con la búsqueda</h4>
      </div>
    </ng-template>
    <div class="my-1 d-flex justify-content-start"
      *ngIf="!modalMode && (showConventionsPayment || showConventionsTransportedValue || showConventionsSelectItems || showConventionsPausedCargos)">
      <div class="conv-btn" (click)="openConventions()">
        <i class="fas fa-circle"></i> Convenciones
      </div>
    </div>
  </div>
</aside>
